<template>
  <div>
  <div class="report" v-if="reportLoaded" id="report">
    <div class="d-print-none">
      <ReportErrors :errors="draftReport.messages" :warning-label="warningLabel"/>
      <v-toolbar flat class="action-toolbar">
        <v-btn v-if="!draftReport.view_only" :disabled="!draftReport.processed" color="primary" @click="loginToFile">Login to file</v-btn>
        <v-btn @click="doPrint">Print</v-btn>
      </v-toolbar>
    </div>
    <C3 v-if="reportType === 'c3'" :report="draftReport"/>
    <C4 v-if="reportType === 'c4'" :report="draftReport"/>
  </div>
  <div v-if="errorDialog">
    <v-card>
      <v-card-text>
    <p>The report cannot be found. It may have already been submitted or you do not have access.</p>
      </v-card-text>
    </v-card>
  </div>
  </div>
</template>

<script>
import C3 from "../reports/C3";
import C4 from "../reports/C4";
import ReportErrors from "@/reports/ReportErrors";
import { publicApp as app } from '@/main';

export default {
  name: "DraftReport",
  components: { C3, C4, ReportErrors },
  data() {
    return {
      draftReport: {},
      reportLoaded: false,
      isLoggedIn: false,
      errorDialog: false
    }
  },
  computed: {
    reportType() {
      return `${ this.draftReport.origin }`.toLowerCase()
    },
    warningLabel() {
      return (this.draftReport.processed) ? "Warning" : "Error";
    },
    committeeId() {
      return this.draftReport.committee_data.committee_id;
    },
    draftId() {
      return this.draftReport.draft_id
    }
  },
  methods: {
    doPrint() {
      window.print();
    },
    loginToFile() {
      window.location.href = `/campaigns/committee/${ this.committeeId }/draft-report/${ this.draftId }?vendor_draft=true&need_cert=true`;
    },
    getDraftIdFromJWT(token) {
      const data = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString())
      return data.draft_id;
    },
    async loadReport(jwt) {
      const draftId = this.getDraftIdFromJWT(jwt)
      try {
        const res = await app.$container.dataService.getDraftReport(jwt)
        this.draftReport = { ...res.data, is_draft: true, draft_id: draftId }
        console.log("draft report: ", this.draftReport)
        this.reportLoaded = true
      } catch (e) {
        this.errorDialog = true
      }
    }
  },
  created() {
    if (this.$route.query.jwt) {
      this.loadReport(this.$route.query.jwt);
    } else {
      this.errorDialog = true;
    }
  },
}
</script>

<style scoped>
.route-link {
  text-decoration: none;
}
.action-toolbar {
  margin-bottom: 1rem;
}

/deep/ .v-toolbar__content {
  padding-left: 4px !important;
}
</style>